import Icon from "../selfcare/Icon.tsx";
import IconTrophy from "../icons/IconTrophy.tsx";

export default function TDC5GTrophySectionComponent() {
    return (
        <section className="mbb-fact-box content">
            <div className="content content--slim">
                <Icon component={IconTrophy}/>
                <div className="text">
                    <h2 className="heading heading--montserrat heading--big heading--left">Vidste du...</h2>
                    <p>
                        At med Hipers 5G-internet får du adgang til stabilt og lynhurtigt internet i Hiper-kvalitet, med <strong>Danmarks bedste 5G-dækning</strong> fra TDC NET, der <strong>dækker 99,9%</strong> af Danmark?
                    </p>
                </div>
            </div>
        </section>
    )
}
